import escapeHtml from 'escape-html';
import { MARK_COLOR, MARK_FONT_SIZE } from '@udecode/plate-font';
import _ from 'lodash';

import { isValidCssColor, shouldAllowExternalColor } from 'components/text_editor_new/lib/should_allow_element_color';

export default function serializeHtmlText(node, { forExternalUse = false, preserveColors = false } = {}) {
  let string = escapeHtml(node.text);

  // We don't need to wrap empty strings in marks. This also messes with the empty paragraph
  // logic that makes <div><br></div> since it expects an empty string, not an awkwardly empty
  // <b><u></u></b> for example.
  if (!string) {
    return string;
  }

  // Serialize marks
  if (node.bold) {
    string = `<b>${string}</b>`;
  }
  if (node.italic) {
    string = `<i>${string}</i>`;
  }
  if (node.underline) {
    string = `<u>${string}</u>`;
  }

  if (node[MARK_COLOR] || node[MARK_FONT_SIZE]) {
    // When serializing for external use (e.g. outbound email), strip near-white colors
    // that come from dark mode theming — they'd be invisible on white email backgrounds.
    // `preserveColors` opts out of that strip (e.g. white text in a dark-backgrounded table cell).
    const rawColor = _.trim(node[MARK_COLOR]);
    const color = forExternalUse && !preserveColors && rawColor && !shouldAllowExternalColor(rawColor) ? '' : rawColor;
    const fontSize = _.trim(node[MARK_FONT_SIZE]);

    const styleParts = [];
    // Validate before interpolating into the style attribute — a parseable CSS color can't carry the
    // characters needed to break out of `style="..."`.
    if (color && isValidCssColor(color)) {
      styleParts.push(`color:${color}`);
    }
    if (fontSize) {
      styleParts.push(`font-size:${fontSize}`);
    }

    const styleString = styleParts.join(';');
    if (styleString) {
      string = `<span style="${styleString}">${string}</span>`;
    }
  }

  // Serialize other line breaks.
  string = string.replace(new RegExp('\\n', 'g'), '<br>');

  return string;
}
